import React from "react";
import cls from './style.module.scss'
import useStyles from "isomorphic-style-loader/useStyles";

export default props =>{
    useStyles(cls);
    return <div className={cls.NormalBox}>
        {props.children}
    </div>
}